/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import * as moment from 'moment';
@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.page.html',
  styleUrls: ['./inbox.page.scss'],
})
export class InboxPage {
  user: any;
  inboxMessages: any = [];
  unreadCount: any;
  page: number;
  perPage: number;
  hasMore: boolean;
  hasSkelton: boolean;
  searchTerm: '';
  constructor(
    private apiService: ApiService,
    public router: Router,
    public storageService: StorageService,
    public navCtrl: NavController,
    public toastService: ToastService
  ) {}

  ionViewWillEnter() {
    this.page = 1;
    this.perPage = 10;
    this.hasMore = true;
    this.inboxMessages=[];
    this.getInboxmessages();
  }
  getInboxmessages() {
    this.hasSkelton = true;
    const params = {
      page: this.page,
      perPage: this.perPage,
    };
    this.apiService.post('user/get-messages', params).subscribe(
      (res) => {
        this.hasSkelton = false;
        if (res.error === false) {
          res.data.inbox.forEach((p) => {
            this.inboxMessages.push(p);
          });
          if (res.data.inbox.length < this.perPage) {
            this.hasMore = false;
          } else {
            this.page++;
          }
        }
      },
      (err) => {
        this.hasSkelton = false;
      }
    );
  }

  messageInfo(data) {
    this.navCtrl.navigateForward('/messageDetail', {
      state: { data },
    });
  }

  doInfinite(infiniteScroll) {
    if (this.hasMore) {
      this.getInboxmessages();
      setTimeout(() => {
        infiniteScroll.target.complete();
      }, 1000);
    } else {
      infiniteScroll.target.complete();
      infiniteScroll.target.disabled = true;
    }
  }
  onSearch(event: any) {

    // if (!event) {
    //   this.filtereditems = this.mbsList;
    // }

    // const newValue =
    //   event.target.value && event.target.value.trim().toLowerCase();
    // if (!newValue || !this.mbsList) {
    //   this.filtereditems = this.mbsList;
    // } else {
    //   if (
    //     this.mbsList.length > 0 &&
    //     typeof this.mbsList[0].description != 'undefined'
    //   ) {
    //     this.filtereditems = this.mbsList.filter(
    //       (item) =>
    //         item.description.toLowerCase().indexOf(newValue) > -1 ||
    //         item.value.toLowerCase().indexOf(newValue) > -1
    //     );
    //     if (!this.filtereditems.length) {
    //     }
    //   } else {
    //   }
    // }
  }

  clearSearch() {
    this.searchTerm = '';
  }

}
